export function checkSize(size: string) {
  switch (size) {
    case 'ads-font-size-01':
      return '12px';
    case 'ads-font-size-02':
      return '14px';
    case 'ads-font-size-03':
      return '16px';
    case 'ads-font-size-04':
      return '18px';
    case 'ads-font-size-05':
      return '20px';
    case 'ads-font-size-06':
      return '24px';
    case 'ads-font-size-07':
      return '28px';
    case 'ads-font-size-08':
      return '32px';
    case 'ads-font-size-09':
      return '36px';
    case 'ads-font-size-10':
      return '42px';
    case 'ads-font-size-11':
      return '48px';
    case 'ads-font-size-12':
      return '54px';
    case 'ads-font-size-13':
      return '60px';
    case 'ads-font-size-14':
      return '68px';
    case 'ads-font-size-15':
      return '76px';
    case 'ads-font-size-16':
      return '84px';
    case 'ads-font-size-17':
      return '92px';
    default:
      return '24px';
  }
}

export function checkColor(color: string) {
  switch (color) {
    case 'ads-color-icon-01':
      return '#0C60A5';
    case 'ads-color-icon-02':
      return '#525A5E';
    case 'ads-color-disabled':
      return '#C6D3D9';
    case 'ads-color-danger':
      return '#DB232D';
    case 'ads-color-inverse':
      return '#FFFFFF';
    case 'ads-color-savings':
      return '#DB232D';
    case 'ads-color-support-error':
      return '#DB232D';
    case 'ads-color-support-success':
      return '#2E8318';
    case 'ads-color-support-warning':
      return '#FDD13A';
    case 'ads-color-support-informational':
      return '#0C60A5';
    default:
      return '#0CD0AF';
  }
}
